import { render, staticRenderFns } from "./resetPart.vue?vue&type=template&id=1121e73c&scoped=true"
import script from "./resetPart.vue?vue&type=script&lang=js"
export * from "./resetPart.vue?vue&type=script&lang=js"
import style0 from "./resetPart.vue?vue&type=style&index=0&id=1121e73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1121e73c",
  null
  
)

export default component.exports